export const userSkipsAddonSelection = () => {
  return {
    type: 'User skips add-on selection',
  };
};

export const userContinuesWithAddonSelection = () => {
  return { type: 'User continues with add-on selection' };
};
